module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.stage === 'scanBarcode') ? _c('scanBarcode', {
    on: {
      "setBarcode": _vm.getBarcode
    }
  }, [_c('div', {
    staticClass: "with-child-centered"
  }, [_c('h3', [_vm._v("請掃描藥單條碼進行"), _c('strong', [_vm._v("取藥")])])])]) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-12",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('drugList', {
    attrs: {
      "singleSelection": false,
      "viewMode": 'medList'
    }
  })], 1)]) : _vm._e(), (_vm.stage === 'setFlowData') ? _c('MultiFlow', {
    attrs: {
      "startActionType": _vm.startActionType,
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress,
      "barcodeData": _vm.barcodeData
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "id": "cancel",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.stage !== 'setFlowData' && _vm.stage !== 'finish') ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "掃描條碼"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'scanBarcode'
      }
    },
    slot: "button-4"
  }) : _vm._e(), (_vm.stage !== 'setFlowData' && _vm.stage !== 'finish') ? _c('action-button', {
    attrs: {
      "slot": "button-5",
      "title": "全部藥物"
    },
    nativeOn: {
      "click": function($event) {
        _vm.stage = 'selectDrug'
      }
    },
    slot: "button-5"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-8",
      "title": "調撥藥品"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow('FETCH_TRANSFER')
      }
    },
    slot: "button-8"
  }) : _vm._e(), (_vm.stage === 'selectDrug') ? _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow('FETCH')
      }
    },
    slot: "button-9"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1acbcaec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrug.vue
// module id = 1406
// module chunks = 1